
export class UsuariModel {
    id: string;
    nom: string;
    cognoms: string;
    password: string;
    email: string;
    codi: string;
    auth: string;
    activitats: string[];
    perfil: string;
    capacitats: string[];
    access_token: string;
    autoritzat: boolean = true;
}

export class PerfilModel {
    id: string;
    descripcio: string;
    capacitats: string[];
}

export class CapacitatModel {
    id: string;
    descripcio: string;
}

import { ICAM } from '../../gitih/models/gitih.model';
export class Registre {
    usuari: string;
    tipus: string;
    id: string;
    dades: ICAM;
    moment: Date;
  }

export class Log {
    nivell: string;
    data: Date;
    idPacient: string;
    funcio: string;
    dades: string;
}

export class LogIcam {
    data: Date;
    idPacient: string;
    tipusLog: string;
    dades: string;
}

export class DiagIcam {
    id: string;
    desc: string;
    durada: Date;
    grup: string;
}

export class DiagNoIcam {
    activitat: string;
    codi: string;
    descripcio: string;
    primerAcces: Date;
    ultimAcces: Date;
    pacients: number;
}